var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "850",
        persistent: "",
        scrollable: "",
        "no-click-animation": "",
        "overlay-color": "grey-500",
      },
      model: {
        value: _vm.dialogVisible,
        callback: function ($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-700--text font-weight-bold",
                    },
                    [_vm._v("Reglas de recepción")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: { click: _vm.close },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "fontBody", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            {
              staticClass: "py-4 px-5 grey-background",
              staticStyle: { "max-height": "70vh" },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "mb-4 pa-4",
                  class: {
                    "d-flex align-center": !_vm.categoryRuleEnabled,
                    "disabled-card":
                      _vm.autoRejectEnabled || _vm.referenceValidationEnabled,
                  },
                  style: !_vm.categoryRuleEnabled ? "min-height: 80px;" : "",
                  attrs: { flat: "" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-space-between align-center",
                      class: {
                        "mb-4": _vm.categoryRuleEnabled,
                        "flex-grow-1": !_vm.categoryRuleEnabled,
                      },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "subtitle-2 grey-700--text font-weight-semibold",
                          },
                          [_vm._v("Regla de la categoría")]
                        ),
                        _c(
                          "div",
                          { staticClass: "body-2 mt-1 grey-500--text" },
                          [_vm._v("Aplica exclusivamente a esta categoría")]
                        ),
                      ]),
                      _c("v-switch", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          "hide-details": "",
                          color: "success",
                          ripple: false,
                          disabled:
                            _vm.autoRejectEnabled ||
                            _vm.referenceValidationEnabled,
                        },
                        model: {
                          value: _vm.categoryRuleEnabled,
                          callback: function ($$v) {
                            _vm.categoryRuleEnabled = $$v
                          },
                          expression: "categoryRuleEnabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.categoryRuleEnabled
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "body-2 grey-500--text mr-3" },
                            [_vm._v("El documento")]
                          ),
                          _c("v-select", {
                            staticStyle: { "max-width": "180px" },
                            attrs: {
                              items: _vm.categoryActionTypeOptions,
                              "item-text": "text",
                              "item-value": "value",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              placeholder: "Selecciona",
                              "menu-props": { bottom: true, offsetY: true },
                            },
                            model: {
                              value: _vm.form.category_action_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "category_action_type", $$v)
                              },
                              expression: "form.category_action_type",
                            },
                          }),
                          _vm.form.category_action_type === "reject"
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "body-2 grey-500--text mx-3" },
                                  [_vm._v("Por")]
                                ),
                                _c("v-select", {
                                  staticClass: "flex-grow-0",
                                  style: { width: _vm.rejectReasonWidth },
                                  attrs: {
                                    items: _vm.rejectReasonOptions,
                                    "item-text": "text",
                                    "item-value": "value",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    placeholder: "Selecciona motivo",
                                    "menu-props": {
                                      bottom: true,
                                      offsetY: true,
                                    },
                                  },
                                  model: {
                                    value: _vm.form.action_rule_true,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "action_rule_true",
                                        $$v
                                      )
                                    },
                                    expression: "form.action_rule_true",
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "v-card",
                {
                  staticClass: "mb-4 pa-4",
                  class: {
                    "d-flex align-center": !_vm.autoRejectEnabled,
                    "disabled-card": _vm.categoryRuleEnabled,
                  },
                  style: !_vm.autoRejectEnabled ? "min-height: 80px;" : "",
                  attrs: { flat: "" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-space-between align-center",
                      class: {
                        "mb-4": _vm.autoRejectEnabled,
                        "flex-grow-1": !_vm.autoRejectEnabled,
                      },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "subtitle-2 grey-700--text font-weight-semibold",
                          },
                          [_vm._v("Rechazo automático por no recepción")]
                        ),
                        _c(
                          "div",
                          { staticClass: "body-2 mt-1 grey-500--text" },
                          [
                            _vm._v(
                              "Rechaza automáticamente facturas que estén registradas en el SII pero que no hayan sido recibidas por correo dentro del plazo definido"
                            ),
                          ]
                        ),
                      ]),
                      _c("v-switch", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          "hide-details": "",
                          color: "success",
                          ripple: false,
                          disabled: _vm.categoryRuleEnabled,
                        },
                        model: {
                          value: _vm.autoRejectEnabled,
                          callback: function ($$v) {
                            _vm.autoRejectEnabled = $$v
                          },
                          expression: "autoRejectEnabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.autoRejectEnabled
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "body-2 grey-500--text mr-3" },
                            [_vm._v("El documento se rechaza por")]
                          ),
                          _c("v-select", {
                            staticStyle: { "max-width": "200px" },
                            attrs: {
                              items: _vm.rejectReasonNoReceptionOptions,
                              "item-text": "text",
                              "item-value": "value",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              "menu-props": { bottom: true, offsetY: true },
                            },
                            model: {
                              value: _vm.form.reject_reason_no_reception,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "reject_reason_no_reception",
                                  $$v
                                )
                              },
                              expression: "form.reject_reason_no_reception",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "body-2 grey-500--text mx-3" },
                            [_vm._v("a los")]
                          ),
                          _c("v-select", {
                            staticStyle: { "max-width": "80px" },
                            attrs: {
                              items: _vm.daysOptions,
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              "menu-props": { bottom: true, offsetY: true },
                            },
                            model: {
                              value: _vm.form.days_doc_not_recv,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "days_doc_not_recv", $$v)
                              },
                              expression: "form.days_doc_not_recv",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "body-2 grey-500--text ml-3" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.form.days_doc_not_recv === 1
                                    ? "día"
                                    : "días"
                                ) + " de espera"
                              ),
                            ]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "300" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  size: "18",
                                                  color: "grey-300",
                                                },
                                              },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("mdi-information-outline")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                133466235
                              ),
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "d-block body-2 grey-500--text pa-3",
                                },
                                [
                                  _vm._v(
                                    "La factura será rechazada automáticamente si no se recibe por correo dentro de este plazo."
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "v-card",
                {
                  staticClass: "mb-4 pa-4",
                  class: {
                    "d-flex align-center": !_vm.referenceValidationEnabled,
                    "disabled-card": _vm.categoryRuleEnabled,
                  },
                  style: !_vm.referenceValidationEnabled
                    ? "min-height: 80px;"
                    : "",
                  attrs: { flat: "" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-space-between align-center",
                      class: {
                        "mb-4": _vm.referenceValidationEnabled,
                        "flex-grow-1": !_vm.referenceValidationEnabled,
                      },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "subtitle-2 grey-700--text font-weight-semibold",
                          },
                          [_vm._v("Validación de referencia del documento")]
                        ),
                        _c(
                          "div",
                          { staticClass: "body-2 mt-1 grey-500--text" },
                          [
                            _vm._v(
                              "Define qué referencia debe incluir el documento"
                            ),
                          ]
                        ),
                      ]),
                      _c("v-switch", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          "hide-details": "",
                          color: "success",
                          ripple: false,
                          disabled: _vm.categoryRuleEnabled,
                        },
                        model: {
                          value: _vm.referenceValidationEnabled,
                          callback: function ($$v) {
                            _vm.referenceValidationEnabled = $$v
                          },
                          expression: "referenceValidationEnabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.referenceValidationEnabled
                    ? [
                        _c(
                          "div",
                          { staticClass: "mb-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "body-1 grey-500--text font-weight-medium mb-2",
                              },
                              [_vm._v("Condición de validación")]
                            ),
                            _c(
                              "v-radio-group",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { "hide-details": "", dense: "" },
                                model: {
                                  value: _vm.form.rule,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "rule", $$v)
                                  },
                                  expression: "form.rule",
                                },
                              },
                              [
                                _c("v-radio", {
                                  staticClass: "mb-1",
                                  attrs: { value: "REF_ALL", dense: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey-500--text",
                                              },
                                              [
                                                _vm._v("Debe tener "),
                                                _c("strong", [_vm._v("todas")]),
                                                _vm._v(" las referencias"),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    4015826025
                                  ),
                                }),
                                _c("v-radio", {
                                  attrs: { value: "REF_SOME", dense: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey-500--text",
                                              },
                                              [
                                                _vm._v("Debe tener "),
                                                _c("strong", [
                                                  _vm._v("al menos una"),
                                                ]),
                                                _vm._v(" referencia"),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1872608068
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider", { staticClass: "my-4" }),
                        _c(
                          "div",
                          { staticClass: "mb-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "body-1 grey-500--text font-weight-medium mb-1",
                              },
                              [_vm._v("Validación de referencia")]
                            ),
                            _c(
                              "div",
                              { staticClass: "body-2 grey-300--text mb-5" },
                              [
                                _vm._v("Si el documento "),
                                _c("strong", [_vm._v("no cumple")]),
                                _vm._v(
                                  " con las referencias configuradas, será "
                                ),
                                _c("strong", [_vm._v("rechazada")]),
                                _vm._v(". Si las "),
                                _c("strong", [_vm._v("cumple")]),
                                _vm._v(", podrás "),
                                _c("strong", [_vm._v("definir la acción")]),
                                _vm._v(" a aplicar"),
                              ]
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              _vm._l(_vm.referenceOptions, function (ref) {
                                return _c(
                                  "v-col",
                                  { key: ref.value, attrs: { cols: "3" } },
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "ma-0 pa-0 mb-2",
                                      attrs: {
                                        value: ref.value,
                                        label: ref.text,
                                        "hide-details": "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.form.parameters,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "parameters", $$v)
                                        },
                                        expression: "form.parameters",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-center mb-4" },
                          [
                            _c(
                              "span",
                              { staticClass: "body-2 grey-500--text mr-3" },
                              [_vm._v("El documento se rechaza por")]
                            ),
                            _c("v-select", {
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                items: _vm.rejectActionOptions,
                                "item-text": "text",
                                "item-value": "value",
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                "menu-props": { bottom: true, offsetY: true },
                              },
                              model: {
                                value: _vm.form.action_rule_false,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "action_rule_false", $$v)
                                },
                                expression: "form.action_rule_false",
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "body-2 grey-500--text mx-3" },
                              [_vm._v("en")]
                            ),
                            _c("v-select", {
                              staticClass: "flex-grow-0",
                              style: {
                                width:
                                  _vm.form.days_rule_false === 0
                                    ? "160px"
                                    : "100px",
                              },
                              attrs: {
                                items: _vm.daysApplyOptions,
                                "item-text": "text",
                                "item-value": "value",
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                "menu-props": { bottom: true, offsetY: true },
                              },
                              model: {
                                value: _vm.form.days_rule_false,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "days_rule_false", $$v)
                                },
                                expression: "form.days_rule_false",
                              },
                            }),
                            _vm.form.days_rule_false !== 0
                              ? _c(
                                  "span",
                                  { staticClass: "body-2 grey-500--text ml-3" },
                                  [_vm._v("desde la recepción del documento")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("v-divider", { staticClass: "mb-4" }),
                        _c("div", { staticClass: "mb-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "body-1 grey-500--text font-weight-medium",
                            },
                            [_vm._v("Resultado de validación de referencias")]
                          ),
                          _c(
                            "div",
                            { staticClass: "body-2 grey-300--text mb-3" },
                            [
                              _vm._v(
                                "Define qué ocurre cuando la factura cumple con las referencias configuradas"
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              "span",
                              { staticClass: "body-2 grey-500--text mr-3" },
                              [_vm._v("El documento")]
                            ),
                            _c("v-select", {
                              staticStyle: { "max-width": "250px" },
                              attrs: {
                                items: _vm.documentActionOptions,
                                "item-text": "text",
                                "item-value": "value",
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                placeholder: "Selecciona una alternativa",
                                "menu-props": { bottom: true, offsetY: true },
                              },
                              model: {
                                value: _vm.form.action_rule_true_validation,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "action_rule_true_validation",
                                    $$v
                                  )
                                },
                                expression: "form.action_rule_true_validation",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "py-2 px-5" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { outlined: "" }, on: { click: _vm.close } },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { loading: _vm.loadingSave, color: "grey-900" },
                  on: { click: _vm.saveRules },
                },
                [_vm._v("Guardar")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }